import { TServicesTableDataCalculation } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const insertAdditionalServices = ({
  reservationId,
  payload,
}: {
  reservationId: string;
  payload: TServicesTableDataCalculation;
}) => {
  return API.post(`api/accommodation/calculations/${reservationId}/services`, payload);
};
